import { graphql } from 'react-relay';

export const gqlPutNuxSurvey = graphql`
  mutation putNuxSurveyMutation($body: InvsysStringRequiredPutObject, $finished: InvsysBooleanRequiredPutObject) {
    invsysPutNuxSurvey(body: $body, finished: $finished) {
      success
    }
  }
`;
